import React from "react";
import { Alert } from "@mui/material";
import { IDocumentFilePreview } from "source/models/document/documentFilePreview";
import { FileType } from "ui/Scripts/source/models/enums";

interface IDocumentListDetailsPanelFileContentProps {
    companyId: string;
    directoryItemId: string;
    documentFilePreview: IDocumentFilePreview;
}

export const DocumentListDetailsPanelFileContent = (props: IDocumentListDetailsPanelFileContentProps) => {
    if (props.documentFilePreview.errorMessage) {
        return (
            <Alert severity="error">{props.documentFilePreview.errorMessage}</Alert>
        );
    }
    return (
        <>
            {!!props.documentFilePreview.html &&
                <div style={{ margin: 0, padding: "10px", width: "100%", height: "100%", flex: "1" }} dangerouslySetInnerHTML={{ __html: props.documentFilePreview.html }} />
            }
            {!!props.documentFilePreview.text &&
                <div style={{ margin: 0, padding: "10px", width: "100%", height: "100%", flex: "1", wordBreak: "break-all" }} >{props.documentFilePreview.text}</div>
            }
            {!!props.documentFilePreview.path && props.documentFilePreview.fileType === FileType.Image &&
                <img style={{ margin: 0, padding: "10px", width: "100%", height: "100%", flex: "1", maxHeight: "calc(100vh - 140px)", objectFit: "contain" }} src={props.documentFilePreview.path}></img>
            }
            {!!props.documentFilePreview.path && props.documentFilePreview.fileType === FileType.Pdf &&
                <object style={{ margin: 0, padding: 0, width: "100%", height: "100%", flex: "1" }} type="application/pdf" data={props.documentFilePreview.path + "#navpanes=0"} width="100%" height="100%"></object>
            }
        </>
    );
};